import { timezones } from '@fortem-monorepo/constants'
import { createColDefs } from '@fortem-monorepo/react-ag'
import { createStatusCellRenderer } from '@fortem-monorepo/react-ag'
import { ClientPricing } from '@fortem-monorepo/web-sdk'

import { tagsColDef } from '@/ag-grid/columns/tag-column/col-def'
import { currencies } from '@/components/forms/CreateProductForm/CreateProductForm.schema'

export const createClientsColDefs = (canEdit: boolean) => {
  return createColDefs<ClientPricing.V2.NewClient>([
    {
      field: 'org_id',
      headerName: 'Org ID',
      width: 60,
      hide: true,
    },
    {
      field: 'org_display_name',
      headerName: 'Org Display Name',
      minWidth: 215,
    },
    {
      field: 'at_time',
      headerName: 'At Time',
      width: 113,
      editable: (params) => {
        return !!params.data?.org_id && canEdit
      },
    },
    {
      field: 'active',
      headerName: 'Active',
      width: 104,
      cellRenderer: activeCellRenderer,
    },
    {
      field: 'timezone',
      headerName: 'Tz',
      width: 150,
      editable: (params) => {
        return !!params.data?.org_id && canEdit
      },
      cellEditor: 'agSelectCellEditor',
      cellEditorParams: { values: timezones },
    },
    tagsColDef({
      field: 'recipients',
      headerName: 'Recipients',
      minWidth: 400,
      editable: (params) => {
        return !!params.data?.org_id && canEdit
      },
    }),
  ])
}

export const createProductsColDefs = () => {
  return createColDefs<ClientPricing.V2.NewProduct>([
    {
      field: 'instrument_id',
      headerName: 'Instrument ID',
      width: 75,
    },
    {
      field: 'expiry_date',
      headerName: 'Expiry Date',
      cellClass: 'text-center',
      width: 150,
      cellRenderer: createStatusCellRenderer({
        // _default(params) {
        //   return params?.value
        // },
        // inProgress: {
        //   label: (params) => {
        //     return <div className={"flex items-center gap-1"}>Expires {params.value}</div>
        //   },
        //   renderIf: (params) => {
        //     const expiry_date = params?.data?.expiry_date
        //     if (!expiry_date) return false
        //     const diff = getDifferenceInDays({ start: new Date(), end: new Date(expiry_date) })
        //     return diff > 0 && diff <= 7
        //   },
        // },
        error: {
          label: (_params) => {
            return <div className={'flex items-center gap-1'}>Expired</div>
          },
          renderIf: (params) => {
            const expiry_date = params?.data?.expiry_date
            if (!expiry_date) return false
            return new Date(expiry_date) < new Date()
          },
        },
      }),
    },
    {
      field: 'isin',
      width: 125,
    },
    {
      field: 'sedol',
      width: 125,
    },
    {
      field: 'bbg_ticker',
      headerName: 'BBG Ticker',
      width: 200,
    },
    {
      field: 'price_type',
      headerName: 'Px Type',
      width: 125,
    },
    {
      field: 'currency',
      width: 150,
      cellEditor: 'agSelectCellEditor',
      cellEditorParams: { values: currencies },
    },
    {
      field: 'long_name',
      width: 400,
    },
  ])
}

const activeCellRenderer = createStatusCellRenderer({
  success: {
    label: 'Active',
    values: [1],
  },
  error: {
    label: 'Disabled',
    values: [0],
  },
})
